"use client";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown, Search, Calendar as CalendarIcon } from "lucide-react";
import useDebounce from "@/hooks/useDebounce";
import { Input } from "@/components/ui/input";
import ReservationRqListTable from "@/components/reservation/reservation-list/reservation-rq-list-table";
import { Button } from "@/components/ui/button";
import { useSearch } from "@/hooks/useSearch";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import { useState, useEffect } from "react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { reservationLinks } from "@/components/lib/SidebarLinks";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Paginat from "@/components/lib/paginat";
import useAuth from "@/hooks/useAuth";
import StaffTableSkeleton from "@/components/skeleton/Staff-skeletion";
import { fetchReservations } from "@/redux/slice/reservation-slice/reservation-slice";

function ReservationRequest() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { user } = useAuth();
  const [firstLoading, setFirstLoading] = useState(true);
  const { reservations, pagination, summary } = useSelector(
    (state) => state.reservation.reservation,
  );
  const [searchText, setSearchText] = useState("");
  const { getLoading } = useSelector((state) => state.reservation.reservation);
  const debouncedSearch = useDebounce(searchText, 700);

  useEffect(() => {
    const fetchData = async () => {
      if (firstLoading) {
        setFirstLoading(true);
      }
      const res = await dispatch(
        fetchReservations({
          page: page,
          limit: perPage,
          restaurant_id: user?.restaurant_id,
            status: "draft",
          reservation_type: "online",
          search: debouncedSearch,
        }),
      );
      if (fetchReservations.fulfilled.match(res)) {
        setFirstLoading(false);
      } else if (fetchReservations.rejected.match(res)) {
        setFirstLoading(false);
        toast.error(res.payload);
      }
    };
    fetchData();
  }, [page, perPage, debouncedSearch]);

  if (firstLoading) return <StaffTableSkeleton links={reservationLinks} />;

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={reservationLinks} />}
      pageName={{ title: "Reservation Request List" }}
      paths={[
        { name: "Home", path: "/home" },
        { name: "Reservation", path: "/reservation/reservation-request-list" },
        {
          name: "Reservation Request List",
          path: "/reservation/reservation-request-list",
        },
      ]}
    >
      <div className="container flex flex-col gap-4">
        <div className="bg-cblack2 rounded-lg p-4">
          <div className="mt-5">
            {/* Search & Filters */}
            <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
              {/* Search Input */}
              <div className="w-[260px]">
                <div className="relative">
                  <Search
                    size={18}
                    className="text-cwhite3 absolute top-2 left-2"
                  />
                  <Input
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search"
                    className="bg-cblack3 pl-8"
                  />
                </div>
              </div>

              {/* Filters & Actions */}
              <div className="flex flex-col gap-1.5 justify-end items-end">
                <div className="flex gap-3 justify-center items-center text-white">
                  {/*  Export */}
                  <Button className="bg-cblack3 border border-gray-600 text-cwhite2">
                    <FileDown /> Export
                  </Button>

                  {/*  Per Page */}
                  <div className="flex gap-1 justify-center items-center">
                    <h3 className="text-white">Show</h3>
                    <Select
                      onValueChange={(value) => setPerPage(Number(value))}
                      //   value={perPage.toString()}
                    >
                      <SelectTrigger className="w-[60px]">
                        <SelectValue placeholder="10" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectGroup>
                          <SelectItem value="10">10</SelectItem>
                          <SelectItem value="20">20</SelectItem>
                          <SelectItem value="40">40</SelectItem>
                        </SelectGroup>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="mt-5">
              {getLoading ? (
                <OnlyTableSekeleton header={false} />
              ) : (
                <ReservationRqListTable data={reservations} />
              )}
            </div>
          </div>
        </div>
        <Paginat
          className="mt-2"
          pagination={pagination}
          onPageChange={(page) => setPage(page)}
        />
      </div>
    </Layout2>
  );
}

export default ReservationRequest;
